<template>
    <div v-if="valid && notDelete" id="outerNotice">
        <div class="main-container">
            <h1>{{title}}</h1>
            <div class="main-container__sub">
                <!--<div class="create-user">{{createUserName}}&nbsp;&nbsp;{{createTime | timeSuffixFilter}}</div>-->
                <!--<div class="signup-info">招生登记日期：{{startTime}}——{{endTime}}</div>-->
                <image-previewer tag="richtext">
                    <div class="content" v-html="content"></div>
                </image-previewer>
            </div>
        </div>
        <div v-if="isStart && state !== 1" class="btn-container">
            <el-button type="primary" @click.native="jumpToPage('outerLogin', {id, schoolId})">
                {{ isEnd ? '查看报名' :'我要报名'}}
            </el-button>
        </div>
    </div>
    <default-page v-else :mes="!valid ? '非法操作！' : '报名已删除！'"></default-page>
</template>

<script>
    import DefaultPage from '@/components/DefaultPage';
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer';
    import moment from 'moment';
    import {
        getNotice
    } from '@/api/primary/outer';
    import baseMixin from '@/mixins/baseMixin';

    export default {
        name: "OuterNotice",
        data() {
            return {
                id: this.$route.query.id,
                title: '',
                content: '',
                startTime: '',
                endTime: '',
                createUserName: '',
                createTime: '',
                schoolId: this.$route.query.schoolId,
                isStart: false,
                isEnd: false,
                state: 1,
                valid: true,
                notDelete: true
            }
        },
        components: {
            ImagePreviewer,
            DefaultPage
        },
        mixins: [baseMixin],
        created() {
            sessionStorage.setItem('outerNoticeId', this.$route.query.id);
            getNotice({
                noticeId: this.id
            })
                .then(res => res.data)
                .then(data => {
                    if (data.result) {
                        const pageData = data.data;
                        this.title = pageData.title;
                        this.content = pageData.content;
                        this.startTime = pageData.startTime;
                        this.endTime = pageData.endTime;
                        this.createUserName = pageData.createUserName;
                        this.createTime = pageData.createTime;
                        this.valid = pageData.schoolId == this.schoolId;
                        this.notDelete = pageData.isDelete != 2;
                        this.isStart = pageData.noticeState !== 1;
                        this.isEnd = pageData.noticeState === 3;
                        if (pageData.state === 1) {
                            this.$message.error('该招生登记尚未发布');
                        } else if(!this.isStart) {
                            this.$message.error('该招生登记尚未开始');
                        }
                        this.state = pageData.state;
                        sessionStorage.setItem('signup_beginyear', pageData.beginYear);
                        sessionStorage.setItem('signup_endyear', pageData.endYear);
                        sessionStorage.setItem('signup_publishtype', pageData.publishType);
                    }
                })
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin.scss";


    .table-container {
        width: 92%;
        min-width: 1200px;
        padding: 5px 4%;
    }

    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }

    .main-container {
        width: 92%;
        min-width: 1200px;
        padding: 5px 4%;
        z-index: 3000;
        position: relative;

        .main-container__sub {
            width: 60%;
            margin: 0 auto;
        }

        h1 {
            text-align: center;
        }

        .content {
            width: 80%;
            margin: 0 auto;
        }

        .create-user {
            float: right;
        }

        .signup-info {
            clear: both;
            text-align: center;
        }
    }

    .btn-container {
        text-align: center;
        z-index: 3000;
        position: relative;
    }

    .qrcode-container {
        z-index: 3000;
        position: relative;
        text-align: center;
    }
</style>
<style lang="scss">
    @import "../../../styles/mixin.scss";
    #outerNotice {
        .content {
            @include richtext;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/outer/OuterNotice.vue